module.exports = __webpack_public_path__ + "static/media/SFWandFireSafesModelNumbers.4a848eec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/SFWandFireSafesModelNumbers.jpg
// module id = 1276
// module chunks = 0